// components
import { Container } from 'components/Grid';
import { TitleRotator } from '../TitleRotator';

// styles
import {
  HeroWrapper,
  Title,
  Subtitle,
  TitleRotatorWrapper,
} from './Hero.styles';

const wordsArray = ['Shippers', 'Carriers', 'Warehouses'];

export function Hero() {
  return (
    <HeroWrapper
      bg={{
        xxlarge: 'images/home/hero/loadsmart-hero-xxlarge@2x.jpg',
        large: 'images/home/hero/loadsmart-hero-large@2x.jpg',
        medium: 'images/home/hero/loadsmart-hero-medium@2x.jpg',
        small: 'images/home/hero/loadsmart-hero-small@2x.jpg',
      }}
    >
      <Container>
        <Title>
          Logistics <br /> Solutions for
          <TitleRotatorWrapper>
            <TitleRotator wordsArray={wordsArray} />
          </TitleRotatorWrapper>
        </Title>
        <Subtitle>
          Moving freight in the most efficient, transparent and automated way.
        </Subtitle>
      </Container>
    </HeroWrapper>
  );
}
